import { useTranslations } from "next-intl";
import { FC } from "react";
import { UseFormRegisterReturn, useFormContext } from "react-hook-form";

type Props = {
  label: string;
  id: string;
  error?: string;
  register: UseFormRegisterReturn;
  options?: string[];
  defaultValue?: string;
  onSelect?: (fieldName: string, value: string) => void;
};

const RadioGroup: FC<Props> = ({
  label,
  id,
  error,
  register,
  options,
  defaultValue,
  onSelect,
}) => {
  const { watch } = useFormContext();
  const selectedValue = watch(register.name);
  const t = useTranslations("form");
  return (
    <fieldset className="flex flex-col border border-neutral-50/10 rounded ">
      <div className="flex flex-col p-3 gap-4">
        <div className="mono">
          <span className={`${error ? "opacity-100" : "opacity-60"}`}>
            {label}
          </span>
          <span
            className={`text-red-500 ${error ? "opacity-100" : "opacity-0 visibility-hidden"}`}
          >
            &nbsp;*
          </span>
        </div>
        <div className="flex gap-2 flex-wrap">
          {options?.map((option, index) => (
            <label
              key={`${id}-${index}`}
              className={`mono cursor-pointer flex items-center gap-2 p-2 border rounded transition-all bg-neutral-800 border-neutral-700 ${
                error ? "border-red-500" : "border-neutral-50/10"
              } ${
                selectedValue === option
                  ? ""
                  : "opacity-60"
              }`}
            >
              <input
                type="radio"
                value={option}
                {...register}
                onChange={(e) => {
                  register.onChange(e);
                  onSelect?.(id, option);
                }}
                className="sr-only"
                checked={
                  selectedValue === option
                    ? true
                    : defaultValue === option
                      ? true
                      : false
                }
              />
              <span>{t(option)}</span>
            </label>
          ))}
        </div>
      </div>
    </fieldset>
  );
};

export default RadioGroup;
